import { useMutation } from 'react-query'
import { getErrorString } from 'src/utils'
import { logging } from './api'
import { toast } from 'sonner'

export function useLogging() {
  return useMutation(logging, {
    onMutate: (values) => {
      console.log(values)
    },
    onError: (error, params, context) => {
      toast.error(getErrorString(error))
    },
  })
}
